export default "__VITE_ASSET__e31f4946__"